import axios from "axios";
import eventStatusModel from "@/core/models/share/status.interface";
import inveteEventModel from "@/core/models/share/inviteEvent.interface";
import inveteAvailableTimeModel from "@/core/models/share/inviteAvailableTime.interface";
import voteEventModel from "@/core/models/share/voteEvent.interface";
import voteEventCountModel from "@/core/models/share/voteEventCount.interface";
import invitePersonModel from "@/core/models/share/invitePerson.interface";

import { content as ExposedModel } from "@/core/models/share/content.interface"
import { Actions, Mutations, Getters, Module } from "@/store/enums/exposedEnums";
import { config } from "@/core/config";
import { useDayjs } from '@/core/hook/useDayjs';
const { dayjs } = useDayjs();
import { apiExposedService as apiService } from '@/core/services/api/apiExposedService';
import { contentParticipantInfo as ExposedParticipantInfoI } from "@/core/models/share/content.interface"
import {
  EventStatus as ParamEventStatus,
  ParticapantStatus as ParamParticapantStatus,
  ResponseStatus as ParamResponseStatus,
  IsResolution as ParamIsResolution,
  HasReply as ParamHasReply,
} from "@/store/enums/paramsEnums";
import { Params } from "@/store/enums/participationEnums";
import { eventResponse } from "@/core/models/share/voteEvent.interface";

import AuthService from "@/core/services/Authservice";
const auth = new AuthService();


const ExposedParticipantInfoI: ExposedParticipantInfoI = {
  EventParticipantId: "",
  Comment: "",
  Permission: "",
  Status: "",
  CreateUTCDateTimeOnDbServer: new Date(),
  UpdateUTCDateTimeOnDbServer: new Date(),
  MemberId: "",
  Member: {
    MemberId: "",
    Name: "",
    Email: "",
    Department: "",
    Title: "",
    Status: "",
    Role: ""
  },
  EventHeaderId: "",
  EventHeader: ""
}

const exposedModules = {
  namespaced: true,
  state() {
    return {
      EventStatuses: new Array<eventStatusModel>(),
      MyParticipantEvents: new Array<inveteEventModel>(),
      //所有參與事件的選項
      MyParticipationEventsAvailableTimes: new Array<inveteAvailableTimeModel>(),
      //所有參與事件中我的回應
      MyParticipationEventsResponses: new Array<voteEventModel>(),
      //指定事件中各選項與統計資訊
      EventSchedularCountWithMyResponse: new Array<voteEventCountModel>(),
      // 取得事件單一參與人員狀態
      EventPartRespStatus: ExposedParticipantInfoI,
      EventResponse: new Array<voteEventModel>(),
    }
  },

  mutations: {
    [Mutations.SetExposed](state: any, payload: ExposedModel) {
      //state.EventStatuses = payload.filter((x) => x.Visiable);
      //console.log(payload)
      state.EventStatuses = payload.Data.Status.filter((x) => x.Visiable);
      state.MyParticipantEvents = payload.Data.Header;
      state.MyParticipationEventsResponses = payload.Data.Participants;
      state.EventSchedularCountWithMyResponse = payload.Data.ParticipantResult;
      state.EventResponse = payload.Data.EventResult;
      state.EventPartRespStatus = payload.Data.ParticipantInfo;
    },
  },

  actions: {
    [Actions.LoadExposed](context: any, payload: { participatantId: string }) {
      return new Promise((resolve, reject) => {
        apiService.getData(payload.participatantId)
          .then((response: any) => {
            context.commit(Mutations.SetExposed, response.data);
            resolve(response);
          })
          .catch((error: any) => {
            reject(error);
          });

      });
    },
    async [Actions.HandMyEventVoteNone](context: any, payload: any) {
      var partId = payload.EventParticipantId;
      var data: invitePersonModel = context.state.EventPartRespStatus;
      data.Status = payload.Status;
      console.log(payload)
      await apiService.putNota(payload.EventParticipantId, payload)
        .then((response: any) => {
          console.log(response);
        })
    },
    async [Actions.HandMyEventVote](context: any, payload: any) {
      var eventId = payload.EventHeaderId;
      var eventResponseId = payload.ParticipantResponseId;
      //console.log(payload)

      if (eventResponseId == "") {

        await apiService.postResponse(payload.EventHeaderId, payload)
          .then((response: any) => {
            //console.log(response);
          })

      } else {
        1
        await apiService.putResponse(payload.ParticipantResponseId, payload)
          .then((response: any) => {
            //console.log(response);
          })


      }
    },

    async [Actions.HandMyMultiEventVote](context: any, payload: { newVote: string, voteData: Array<eventResponse> }) {
      //console.log(payload)

      if (payload.newVote == "Y") {

        await apiService.postMultiResponse(payload.voteData)
          .then((response: any) => {
            //console.log(response);
          })

      } else {
        1
        await apiService.putMultiResponse(payload.voteData)
          .then((response: any) => {
            //console.log(response);
          })


      }
    },
  },

  getters: {
    [Getters.EventStatuses]: (state: { EventStatuses: eventStatusModel[] }) => state.EventStatuses,
    [Getters.TheParticipantEvent]: (state: { MyParticipantEvents: inveteEventModel[] }) => state.MyParticipantEvents,
    [Getters.EventSchedularCountWithMyResponse]:
      (context: any) => (sorttype: string) => {
        if (
          context.EventSchedularCountWithMyResponse &&
          context.EventSchedularCountWithMyResponse.length
        ) {
          context.EventSchedularCountWithMyResponse.sort(function (
            a: voteEventCountModel,
            b: voteEventCountModel
          ) {
            switch (sorttype) {
              case Params.SortByStartTime: //order by time
                let keyA = a.ScheduleStartUTCDateTime,
                  keyB = b.ScheduleStartUTCDateTime;
                if (keyA > keyB) return 1;
                if (keyA < keyB) return -1;
                if (a.AgreeCount != b.AgreeCount) {
                  return b.AgreeCount - a.AgreeCount;
                }
                return 0;
              case Params.SortByAgreeCount:
              default:
                //order by agree
                if (a.AgreeCount != b.AgreeCount) {
                  return b.AgreeCount - a.AgreeCount;
                } else {
                  let keyA = a.ScheduleStartUTCDateTime,
                    keyB = b.ScheduleStartUTCDateTime;
                  if (keyA > keyB) return 1;
                  if (keyA < keyB) return -1;
                  return 0;
                }
            }
          });
        }
        //console.log("EventSchedularCountWithMyResponse", context.EventSchedularCountWithMyResponse)
        return context.EventSchedularCountWithMyResponse;
      },
    [Getters.EventResponse](context: any) {
      return context.EventResponse;
    },
    [Getters.InvitMember]: (state: { MyParticipationEventsResponses: invitePersonModel[] }) => state.MyParticipationEventsResponses,
    [Getters.EventPartRespStatus]: (state: { EventPartRespStatus: ExposedParticipantInfoI[] }) => state.EventPartRespStatus,
    [Getters.MyParticipationEventsResponses]: (state: { MyParticipationEventsResponses: invitePersonModel[] }) => state.MyParticipationEventsResponses,
  },
};

export { Module, exposedModules };
